/**
* Tabbed Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // make active button have tabindex of 1
      $( '.tabbed-content__btn' ).on( 'toggleAfter', ( event ) => {
        if ( window.easyToggleState.isActive( event.target ) && window.matchMedia( '(min-width: 1024px)' ).matches ) {
          $( event.target ).attr( 'tabindex', 0 );
        } else {
          $( event.target ).attr( 'tabindex', -1 );
        }
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          $( '.tabbed-content__btn' ).each( function( index, element ) {
            const radioGroup = $( element ).data( 'll-group' );
            $( element ).data( 'toggle-radio-group', radioGroup ).attr( 'data-toggle-radio-group', radioGroup );
            if ( $( element ).hasClass( 'is-open' ) ) {
              $( element ).attr( 'tabindex', 0 );
            } else {
              $( element ).attr( 'tabindex', -1 );
            }
          } );
          if ( $( '.tabbed-content__btn.is-open' ).length === 0 ) {
            $( $( '.tabbed-content__btn' )[0] ).trigger( 'click' );
          }
        } else {
          $( '.tabbed-content__btn' ).each( function( index, element ) {
            $( element ).attr( 'tabindex', 0 );
            $( element ).removeAttr( 'data-toggle-radio-group' );
          } );
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 1024px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-content', COMPONENT );
} )( app );
